import { Form, FormControlProps } from 'react-bootstrap';
import React from 'react';

interface Props extends FormControlProps {
    required?: boolean;
    name?: string;
}

const Component: React.FC<Props> = ({ ...props }) => {
    const { required = true, ...restProps } = props;
    if (required) {
        return (
            required && (
                <Form.Control
                    type="text"
                    required={props.required}
                    style={{
                        opacity: 0,
                        position: 'absolute',
                    }}
                    {...restProps}
                />
            )
        );
    }
    return null;
};
Component.displayName = 'RequiredField';

export const RequiredField = Object.assign(Component, {});
